/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled    from 'styled-components';
import { Media } from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTableListItemTitle = styled.div`
  display: block;
  font-weight: 700;
  ${Media.Tablet`
    flex-basis: 130px;
  `} 
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTableListItemTitle/index.js